import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFocusZoomIn: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFocusZoomIn"><Path d="M3.5 8V3.5H8M3.5 16V20.5H8M16 3.5H20.5V8M20.5 16V20.5H16M8.5 12H15.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFocusZoomIn;
